import React from "react";

const ProjectQaNdtBookingsInspectorsIndex = React.lazy(() => import("./index"));
const NewProjectQaNdtBookingsInspectors = React.lazy(() => import("./new"));
const EditProjectQaNdtBookingsInspectors = React.lazy(() => import("./edit"));

export default [
  { path: "/project/qa/ndt_bookings/inspectors/:id/edit", component: EditProjectQaNdtBookingsInspectors, name: "Edit ProjectQaNdtBookingsInspector" },
  { path: "/project/qa/ndt_bookings/inspectors/new", component: NewProjectQaNdtBookingsInspectors, name: "New ProjectQaNdtBookingsInspector" },
  { path: "/project/qa/ndt_bookings/inspectors", component: ProjectQaNdtBookingsInspectorsIndex, name: "ProjectQaNdtBookingsInspectors" },
];
